import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

/**
 * Hero component
 */
export default class Hero extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Hero',
    refs: ['images[]', 'buttons[]'],
  };

  index = 0;

  currentIndex = 0;

  isAnimating = false;

  /**
   * Mounted
   */
  mounted() {
    this.handleLazyVideo();
    setInterval(this.next.bind(this), 5000);
  }

  /**
   * Handle lazy video
   */
  handleLazyVideo() {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.js-lazy-video'));

    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((video) => {
          if (video.isIntersecting) {
            for (const source in video.target.children) {
              if (video.target.children) {
                const videoSource = video.target.children[source];
                if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                  videoSource.src = videoSource.dataset.src;
                }
              }
            }

            video.target.load();
            video.target.classList.remove('js-lazy-video');
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });

      lazyVideos.forEach((lazyVideo) => {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  }

  /**
   * Show next image
   */
  next() {
    this.index = (this.index + this.$refs.images.length + 1) % this.$refs.images.length;
    this.$refs.images.forEach((image, imageIndex) => {
      toggleClass(image, 'opacity-0', imageIndex !== this.index);
      toggleClass(image, 'delay-300', imageIndex === this.index);
    });
  }

  /**
   * Switch buttons classes
   * @param {number} index
   */
  switchButtonsClasses(index) {
    this.$refs.buttons.forEach((button, buttonIndex) => {
      toggleClass(button, 'hero__foldable-button--current', buttonIndex === index);
    });
  }

  /**
   * Animated foldable buttons
   * @param {Event} _
   * @param {number} index
   */
  onButtonsMouseenter(_, index) {
    if (!this.isAnimating) {
      this.isAnimating = true;

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);
      this.switchButtonsClasses(index);
    }
  }

  /**
   * Animated foldable buttons
   * @param {Event} _
   * @param {number} index
   */
  onButtonsMousemove(_, index) {
    if (!this.isAnimating) {
      this.isAnimating = true;

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);
      this.switchButtonsClasses(index);
    }
  }
}
